<template>
  <HoverCardRoot>
    <HoverCardTrigger as-child>
      <RouterLink
        :to="{ name: hasLedger ? 'internalLedgerCurrentSession' : 'internalLedgerCurrentSelect' }"
        :class="['btn btn-square btn-neutral indicator', $props.class]"
      >
        <FontAwesomeIcon :icon="faCashRegister" />
        <span
          v-if="hasLedgerSession"
          class="indicator-item status animate-ping"
          :class="statusColor"
        />
        <span class="indicator-item status" :class="statusColor" />
      </RouterLink>
    </HoverCardTrigger>
    <HoverCardPortal>
      <HoverCardContent :side-offset="4" class="bg-base-300 flex flex-col gap-2 rounded p-2 shadow">
        <SourceInfo v-if="ledger" :source="ledger?.source" />
        <div class="join">
          <span class="join-item badge badge-neutral">
            <span class="indicator-item status" :class="statusColor" />
            {{ ledger?.name ?? $t('routes.internalLedgerCurrentSession.noSession') }}
          </span>
          <span
            v-if="ledger"
            class="join-item badge"
            :class="internalLedgerSessionStatusInfo?.className"
            :title="internalLedgerSessionStatusInfo?.description"
          >
            <FontAwesomeIcon :icon="internalLedgerSessionStatusInfo?.icon" />
            {{ internalLedgerSessionStatusInfo?.title }}
          </span>
        </div>
        <HoverCardArrow class="fill-base-300" />
      </HoverCardContent>
    </HoverCardPortal>
  </HoverCardRoot>
</template>

<script lang="ts" setup>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { useLedgerSession } from '../../stores/ledgerSessionStore';
import { faCashRegister } from '@fortawesome/free-solid-svg-icons';
import { computed } from 'vue';
import {
  HoverCardPortal,
  HoverCardRoot,
  HoverCardTrigger,
  HoverCardContent,
  HoverCardArrow,
} from 'reka-ui';
import { InternalLedgerSessionStatus } from '@konsolenkost-de/acquisition_store_server_sdk_vue';
import SourceInfo from '../source/SourceInfo.vue';
import { useInternalLedgerSessionStatusInfo } from '../../composables/offer/useInternalLedgerSessionStatusInfo';

defineProps<{
  class?: string;
}>();

const { hasLedger, hasLedgerSession, ledger, ledgerSession } = useLedgerSession();
const { internalLedgerSessionStatusInfo } = useInternalLedgerSessionStatusInfo(
  'badge',
  computed(() => ledgerSession.value?.status ?? InternalLedgerSessionStatus.CLOSED),
);

const statusColor = computed(() => {
  if (!hasLedger.value) return 'status-neutral';

  switch (ledgerSession?.value?.status) {
    case InternalLedgerSessionStatus.OPEN:
      return 'status-success';
    case InternalLedgerSessionStatus.COUNTING_OPEN:
    case InternalLedgerSessionStatus.COUNTING_CLOSED:
      return 'status-warning';
    default:
      return 'status-error';
  }
});
</script>
